/**
 * `/admin/announcements` - spec 18 N-1.
 *
 * Sending is immediate and cannot be undone: the server writes one inbox row per
 * active member in the same request, and the push worker delivers them. That is
 * why the audience count has its own endpoint - the screen shows the reach
 * before the admin commits.
 */

import { request } from "./client";

export type Announcement = {
  id: string;
  title: string;
  body: string;
  /** Null when the admin who sent it has since been removed. */
  created_by: string | null;
  created_by_name: string | null;
  recipient_count: number;
  created_at: string;
};

export type AnnouncementPage = {
  items: Announcement[];
  total: number;
  limit: number;
  offset: number;
};

export type AnnouncementOutcome = { announcement: Announcement; message: string };

/** The server's own limits (`app/schemas/announcements.py`). */
export const TITLE_MAX = 120;
export const BODY_MAX = 1000;

export function fetchAnnouncements(query: { limit?: number; offset?: number } = {}): Promise<AnnouncementPage> {
  return request<AnnouncementPage>("/admin/announcements", { query: { ...query } });
}

export function fetchAnnouncementAudience(): Promise<{ recipient_count: number }> {
  return request<{ recipient_count: number }>("/admin/announcements/audience");
}

export function sendAnnouncement(payload: { title: string; body: string }): Promise<AnnouncementOutcome> {
  return request<AnnouncementOutcome>("/admin/announcements", { method: "POST", body: payload });
}
